import { useState } from 'react';
import getGuaranteeDocument from '../../../../api/bank/getGuaranteeDocument';
import Button from '../../../../components/Button/Button';
import extractErrorMessage from '../../../../utils/extractErrorMessage';
import alert from '../../../../helpers/alert';

const HalykGetGuaranteeLetter = ({ appealId, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const getDocument = async () => {
    setLoading(true);
    try {
      await getGuaranteeDocument(appealId);
      onSuccess && onSuccess();
    } catch (e) {
      alert.error(extractErrorMessage(e?.response?.data) || e?.response?.data || 'ÐÑÐ¸Ð±ÐºÐ° Ð¿ÑÐ¸ Ð¿Ð¾Ð»ÑÑÐµÐ½Ð¸Ð¸ ÐÐ°ÑÐ°Ð½ÑÐ¸Ð¹Ð½Ð¾Ð³Ð¾ Ð¿Ð¸ÑÑÐ¼Ð°');
    } finally {
      setLoading(false);
    }
  };

  return (
      <Button fill disabled={loading} onClick={getDocument} text="ÐÐ¾Ð²ÑÐ¾ÑÐ½Ð¾ Ð·Ð°Ð¿ÑÐ¾ÑÐ¸ÑÑ Ð³Ð°ÑÐ°Ð½ÑÐ¸Ð¹Ð½Ð¾Ðµ Ð¿Ð¸ÑÑÐ¼Ð¾" />
  );
};

export default HalykGetGuaranteeLetter;
